import React, { Component } from 'react'
import { pxToRem, initializeArrayWithRange } from 'utils/helpers'
import { Flex, Box } from 'components/atoms/Layout'
import { Text } from 'components/atoms/Typography'
import Button from 'components/atoms/Button'
import RangeSlider from 'components/organisms/RangeSlider'
import Container from 'components/atoms/Container'
import { Spring } from 'react-spring/renderprops'
import { springConfig } from 'config/theme'
import ModalRent from '../components/Dialog'
import { calculateAffordableHomeValue } from './helpers'

const INPUT_MIN = 1500
const INPUT_MAX = 8500
const INPUT_STEP = 100

const moneyWastedOnRent = (amount) => {
  let benefit = 0
  let res = 0
  return initializeArrayWithRange(3, 0).reduce((currentValue) => {
    benefit = currentValue === 0 ? amount : benefit
    res += benefit * 12
    benefit += benefit * 0.05
    return res
  })
}

const localeStringConfig = [
  'en',
  {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
]

class RentFormSlider extends Component {
  state = {
    rentPerMonth: 3500,
    affordableHomeValue: 550000,
    savedAtTax: Math.round(moneyWastedOnRent(3500) * 0.22),
    rentWastedMoney: moneyWastedOnRent(3500),
    isModalOpen: false,
    isSuccess: false,
  }

  getMoneyWastedOnRent = ([value]) => {
    this.setState({
      rentPerMonth: value,
      rentWastedMoney: moneyWastedOnRent(Number(value)),
      savedAtTax:
        Number(value) > 6000
          ? 50000
          : Math.round(moneyWastedOnRent(Number(value)) * 0.22),
      affordableHomeValue: calculateAffordableHomeValue(value),
    })
  }

  handleToggleModal = () => {
    this.setState(({ isModalOpen }) => ({
      isModalOpen: !isModalOpen,
    }))
  }

  handleSubmitForm = (e) => {
    e.preventDefault()
    const { rentPerMonth } = this.state
    this.setState({ isSuccess: rentPerMonth >= 2000 })
    this.handleToggleModal()
  }

  render() {
    const {
      rentPerMonth,
      affordableHomeValue,
      rentWastedMoney,
      savedAtTax,
      isSuccess,
      isModalOpen,
    } = this.state
    return (
      <Container>
        <Box data-aos="fade-up">
          <Box textAlign="center" mb="xl">
            <Text mb="m" fontSize="xl">
              How much is your rent?
            </Text>
            <Text color="heading" fontSize={pxToRem(64)} fontWeight="semi_bold">
              {Number(rentPerMonth).toLocaleString(...localeStringConfig)}
            </Text>
          </Box>
          <form onSubmit={this.handleSubmitForm}>
            <Flex
              maxWidth={{
                tablet: pxToRem(600),
              }}
              flexDirection="column"
              justifyContent="center"
              m="0 auto"
            >
              <RangeSlider
                domain={[INPUT_MIN, INPUT_MAX]}
                step={INPUT_STEP}
                onUpdate={this.getMoneyWastedOnRent}
                values={[rentPerMonth]}
              />
              <Flex my="xl" justifyContent="space-between">
                <Box mt="m" mr="s">
                  <Text textAlign="center" fontSize="s" mb={pxToRem(40)}>
                    Home you could afford:
                  </Text>
                  <Text
                    textAlign="center"
                    color="heading"
                    fontSize="l"
                    fontWeight="semi_bold"
                  >
                    <Spring to={{ affordableHomeValue }} config={springConfig}>
                      {({ affordableHomeValue }) =>
                        affordableHomeValue.toLocaleString(
                          ...localeStringConfig
                        )
                      }
                    </Spring>
                  </Text>
                </Box>
                <Box mt="m" mr="s">
                  <Text textAlign="center" fontSize="s">
                    Amount of saving at tax time
                  </Text>
                  <Text textAlign="center" fontSize="s" mb="m">
                    (in 3 years)
                  </Text>
                  <Text
                    textAlign="center"
                    fontSize="l"
                    fontWeight="semi_bold"
                    color="heading"
                  >
                    <Spring to={{ savedAtTax }} config={springConfig}>
                      {({ savedAtTax }) =>
                        savedAtTax.toLocaleString(...localeStringConfig)
                      }
                    </Spring>
                  </Text>
                </Box>
                <Box mt="m">
                  <Text textAlign="center" fontSize="s">
                    Money wasted on rent
                  </Text>
                  <Text textAlign="center" fontSize="s" mb="m">
                    (in 3 years):
                  </Text>
                  <Text
                    textAlign="center"
                    fontSize="l"
                    fontWeight="semi_bold"
                    color="heading"
                  >
                    <Spring to={{ rentWastedMoney }} config={springConfig}>
                      {({ rentWastedMoney }) =>
                        rentWastedMoney.toLocaleString(...localeStringConfig)
                      }
                    </Spring>
                  </Text>
                </Box>
              </Flex>
              <Flex justifyContent="center" mt={['m', 'm', '0']}>
                <Button.Filled
                  type="submit"
                  fontSize="m"
                  height={pxToRem(56)}
                  px={(0, 0, [pxToRem(50)])}
                >
                  CONTINUE
                </Button.Filled>
              </Flex>
            </Flex>
          </form>
        </Box>
        <ModalRent
          onCloseModalButtonClick={this.handleToggleModal}
          isModalOpen={isModalOpen}
          isSuccess={isSuccess}
        />
      </Container>
    )
  }
}

export default RentFormSlider
